(() => {
  const body = document.body;
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
  }).format((cents || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#039;', '"':'&quot;' }[char]));
  const campaignKeys = ['angle', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const campaignParams = new URLSearchParams(window.location.search);
  const campaignContext = campaignKeys.reduce((result, key) => {
    const value = campaignParams.get(key);
    if (value) result[key] = value;
    return result;
  }, {});
  try {
    const currentContext = { ...campaignContext };
    const storedContext = JSON.parse(sessionStorage.getItem('ravira_campaign_context') || '{}');
    Object.assign(campaignContext, storedContext, currentContext);
    if (Object.keys(campaignContext).length) sessionStorage.setItem('ravira_campaign_context', JSON.stringify(campaignContext));
  } catch (error) {
    /* Analytics must not interrupt the shopping flow when storage is unavailable. */
  }
  const track = (event, details = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      page_type: body.dataset.pageType || null,
      landing_page_template: body.dataset.templateName || null,
      ...campaignContext,
      ...details
    });
  };

  const selectedOption = (scope) => qs('input[name="selling_plan"]:checked', scope)?.closest('[data-purchase-option]') || null;

  const purchaseDetails = (root, selected = null) => {
    const option = selected || selectedOption(root);
    const variantInput = qs('[name="id"]', root);
    const sellingPlanInput = option ? qs('input[name="selling_plan"]', option) : null;
    const quantity = Number(option?.dataset.purchaseQuantity || 1);
    return {
      cta_location: root?.dataset.purchaseLocation || 'unknown',
      product_id: root?.dataset.productId || null,
      variant_id: variantInput?.value || null,
      selling_plan_id: sellingPlanInput?.value || null,
      purchase_type: option?.dataset.purchaseType || 'one-time',
      quantity,
      price: Number(option?.dataset.purchasePrice || 0)
    };
  };

  // The standalone 60-day option is 2 bottles; its "Make it a 90-day supply?" checkbox makes it 3.
  function syncBundleSelection(option) {
    const toggle = qs('[data-bundle-toggle]', option);
    const three = Boolean(toggle?.checked);
    const quantity = three ? 3 : 2;
    const unitPrice = Number(option.dataset.unitPrice || 0);
    const total = Number(three ? option.dataset.bundleThreeTotal : option.dataset.bundleTwoTotal);
    option.dataset.purchaseQuantity = String(quantity);
    option.dataset.purchasePrice = String(total);
    option.dataset.purchaseDisplayPrice = money(total);
    option.dataset.purchaseComparePrice = money(unitPrice * quantity);
    option.dataset.purchaseCta = `Add ${quantity} Bottles · ${money(total)}`;
    option.dataset.purchaseSticky = `One-time · ${quantity} bottles`;
    option.dataset.bundleName = (three ? option.dataset.bundleThreeName : option.dataset.bundleTwoName) || '';
    const set = (selector, text) => { const node = qs(selector, option); if (node) node.textContent = text; };
    set('[data-bundle-title]', `${quantity * 30}-Day Supply`);
    set('[data-bundle-supply]', `${quantity} bottles · ${money(Math.round(total / quantity))} per bottle`);
    set('[data-bundle-price]', money(total));
    set('[data-bundle-compare]', money(unitPrice * quantity));
    set('[data-bundle-badge]', `Save ${money(unitPrice * quantity - total)}`);
    toggle?.closest('.bundle-upgrade')?.classList.toggle('is-selected', three);
  }

  const renderPurchaseCta = (node, label, comparePrice = '') => {
    if (!node) return;
    node.replaceChildren();
    const primary = document.createElement('span');
    primary.className = 'button__cta-price';
    primary.textContent = label;
    node.append(primary);
    if (comparePrice) {
      const compare = document.createElement('span');
      compare.className = 'button__compare-price';
      compare.textContent = comparePrice;
      node.append(compare);
      node.setAttribute('aria-label', `${label}; regular price ${comparePrice}`);
    } else {
      node.setAttribute('aria-label', label);
    }
  };

  function applyPurchaseSelection(root, report = false) {
    const selected = selectedOption(root);
    if (!selected) return;
    qsa('[data-bundle-option]', root).forEach(syncBundleSelection);
    const type = selected.dataset.purchaseType || 'one-time';
    const quantity = type === 'subscription' ? 1 : Number(selected.dataset.purchaseQuantity || 1);
    const price = Number(selected.dataset.purchasePrice || 0);
    const displayPrice = selected.dataset.purchaseDisplayPrice || money(price);
    const cta = selected.dataset.purchaseCta || `Add to Cart · ${money(price)}`;
    const comparePrice = selected.dataset.purchaseComparePrice || '';
    const previousType = root.dataset.purchaseSelected || root.dataset.purchaseDefault || 'one-time';
    const quantityInput = qs('[data-purchase-quantity-input]', root);
    if (quantityInput) quantityInput.value = String(quantity);
    qsa('[data-bundle-upgrades]', root).forEach((node) => { node.hidden = node.closest('[data-purchase-option]') !== selected; });
    qsa('[data-selected-price]', root).forEach((node) => { node.textContent = displayPrice; });
    qsa('[data-selected-type]', root).forEach((node) => {
      node.textContent = type === 'subscription' ? 'subscription · renews every month'
        : quantity > 1 ? `one-time · ${quantity} bottles · ${quantity * 30}-day supply` : 'one-time purchase · 30-day supply';
    });
    qsa('[data-purchase-cta-target]', root).forEach((node) => renderPurchaseCta(node, cta, comparePrice));
    qsa('[data-purchase-summary]', root).forEach((summary) => {
      const supply = qs('[data-summary-supply]', summary);
      const renewal = qs('[data-summary-renewal]', summary);
      const shipping = qs('[data-summary-shipping]', summary);
      if (supply) supply.textContent = `${quantity} bottle${quantity > 1 ? 's' : ''} · ${quantity * 30}-day supply`;
      if (renewal) renewal.textContent = type === 'subscription' ? renewal.dataset.renewalSubscription : renewal.dataset.renewalOneTime;
      if (shipping) shipping.textContent = type === 'subscription' ? shipping.dataset.shippingSubscription : shipping.dataset.shippingOneTime;
    });

    if (qs('[data-main-purchase]', root)) {
      const sticky = qs('[data-sticky-atc]');
      const stickyPrice = qs('[data-sticky-price]', sticky);
      const stickyType = qs('[data-sticky-type]', sticky);
      const stickyButton = qs('[data-sticky-submit]', sticky);
      if (stickyPrice) stickyPrice.textContent = displayPrice;
      if (stickyType) stickyType.textContent = type === 'subscription' ? 'Subscribe' : (selected.dataset.purchaseSticky || 'One-time');
      if (stickyButton && !stickyButton.disabled) renderPurchaseCta(stickyButton, 'Add to Cart');
    }
    const selectionKey = `${type}:${quantity}`;
    if (report) {
      const details = purchaseDetails(root, selected);
      track('ravira_purchase_type_selected', details);
      track('purchase_type_select', { purchase_type: type, displayed_price: price, quantity });
      if (type !== previousType) {
        track('ravira_purchase_type_switched', { ...details, from_purchase_type: previousType, to_purchase_type: type });
        track('purchase_type_switch', { from_purchase_type: previousType, to_purchase_type: type });
      }
      if (type === 'one-time' && root.dataset.purchaseSelection !== selectionKey) {
        track('ravira_bundle_selected', { ...details, bundle_name: selected.dataset.bundleName || null });
      }
    }
    root.dataset.purchaseSelected = type;
    root.dataset.purchaseSelection = selectionKey;
  }

  function setDrawer(drawer, open, trigger) {
    if (!drawer) return;
    drawer.hidden = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    body.classList.toggle('is-locked', open);
    if (trigger) trigger.setAttribute('aria-expanded', String(open));
    if (open) {
      const focusTarget = qs('button, a, input', drawer);
      if (focusTarget) requestAnimationFrame(() => focusTarget.focus());
    } else if (trigger) requestAnimationFrame(() => trigger.focus());
  }

  const menu = qs('[data-mobile-menu]');
  const menuToggle = qs('[data-menu-toggle]');
  if (menuToggle) menuToggle.addEventListener('click', () => setDrawer(menu, true, menuToggle));
  qsa('[data-menu-close]').forEach((button) => button.addEventListener('click', () => setDrawer(menu, false, menuToggle)));
  qsa('[data-menu-link]', menu).forEach((link) => link.addEventListener('click', () => setDrawer(menu, false, menuToggle)));

  const cartDrawer = qs('[data-cart-drawer]');
  const cartOpen = qs('[data-cart-open]');
  qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', () => setDrawer(cartDrawer, false, cartOpen)));
  if (cartOpen) cartOpen.addEventListener('click', async () => {
    await refreshCart();
    setDrawer(cartDrawer, true, cartOpen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (menu && !menu.hidden) setDrawer(menu, false, menuToggle);
      if (cartDrawer && !cartDrawer.hidden) setDrawer(cartDrawer, false, cartOpen);
      return;
    }
    if (event.key !== 'Tab') return;
    const openDrawer = [menu, cartDrawer].find((drawer) => drawer && !drawer.hidden);
    if (!openDrawer) return;
    const focusable = qsa('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])', openDrawer);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const cartRoot = `${window.Shopify?.routes?.root || '/'}cart`;
  const cartRequest = async (path, body) => {
    const response = await fetch(`${cartRoot}${path}`, body ? {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Cart request failed: ${path}`);
    return response.json();
  };
  const offerConfig = (() => {
    try { return JSON.parse(qs('[data-ravira-offer]')?.textContent || 'null'); } catch (error) { return null; }
  })();
  const bundleTotal = (quantity) => offerConfig?.enabled ? Number(offerConfig.totals?.[quantity] || 0) : 0;
  const isOfferLine = (item) => offerConfig && String(item.variant_id) === String(offerConfig.variant_id);
  const oneTimeOfferQuantity = (cart) => cart.items
    .filter((item) => isOfferLine(item) && !item.selling_plan_allocation)
    .reduce((sum, item) => sum + item.quantity, 0);

  // Bundle prices come from Shopify automatic discounts. If the cart does not show the expected
  // total, report it so a missing or changed discount is found quickly. The drawer always shows
  // Shopify's real price.
  function checkBundlePrice(cart, source) {
    const quantity = oneTimeOfferQuantity(cart);
    const expected = bundleTotal(quantity);
    if (!expected) return;
    const actual = cart.items.filter((item) => isOfferLine(item) && !item.selling_plan_allocation)
      .reduce((sum, item) => sum + item.final_line_price, 0);
    if (actual !== expected) {
      console.warn(`Ravira bundle price mismatch: ${quantity} bottles expected ${expected}, cart shows ${actual}`);
      track('ravira_bundle_price_mismatch', { quantity, expected_price: expected, cart_price: actual, source });
    }
  }

  async function refreshCart() {
    if (!cartDrawer) return null;
    try {
      const cart = await cartRequest('.js');
      renderCart(cart);
      return cart;
    } catch (error) {
      console.error('Cart update failed', error);
      return null;
    }
  }

  function cartUpsell(cart) {
    if (!offerConfig?.enabled || cart.currency !== offerConfig.currency) return '';
    const quantity = oneTimeOfferQuantity(cart);
    const next = quantity + 1;
    const nextTotal = bundleTotal(next);
    const currentTotal = quantity === 1 ? offerConfig.unit_price : bundleTotal(quantity);
    if (!nextTotal || !currentTotal || quantity < 1) return '';
    const step = nextTotal - currentTotal;
    const heading = next === 2 ? 'Make it a 60-day supply?' : 'Make it a 90-day supply?';
    const line = next === 2 ? `Add a second bottle for just ${money(step)} more.` : `Add a third bottle for just ${money(step)} more.`;
    return `
      <div class="cart-upsell">
        <div>
          <strong>${heading}</strong>
          <p>${line} Your ${next} bottles come to ${money(nextTotal)} with free shipping.</p>
        </div>
        <button class="button button--outline" type="button" data-cart-upsell="${next}">Add bottle · ${money(step)}</button>
      </div>`;
  }

  function renderCart(cart) {
    qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const items = qs('[data-cart-items]');
    const footer = qs('[data-cart-footer]');
    if (!items || !footer) return;
    footer.hidden = cart.item_count === 0;
    if (!cart.items.length) {
      items.innerHTML = '<div class="cart-empty"><p>Your cart is ready for a fresh start.</p><a class="button button--primary" href="/products/ashwagandha-plus-1">Shop Ravira STEADY</a></div>';
      return;
    }
    items.innerHTML = cart.items.map((item, index) => {
      const plan = item.selling_plan_allocation;
      const purchase = plan ? 'Subscribe &amp; Save · renews automatically'
        : `One-time · ${item.quantity * 30}-day supply`;
      const discounts = (item.line_level_discount_allocations || [])
        .map((allocation) => escapeHtml(allocation.discount_application?.title || '')).filter(Boolean);
      const discounted = item.original_line_price > item.final_line_price;
      return `
      <article class="cart-item">
        ${item.image ? `<img src="${escapeHtml(item.image)}&width=184" alt="${escapeHtml(item.product_title)}" width="92" height="92">` : '<div></div>'}
        <div>
          <h3>${escapeHtml(item.product_title.includes('Ravira') ? item.product_title : `Ravira ${item.product_title}`)}</h3>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}
          <p>${purchase}</p>
          ${discounts.length ? `<p class="cart-item__discount">${discounts.join(' · ')}</p>` : ''}
          <div class="cart-item__controls">
            <div class="cart-item__quantity" role="group" aria-label="Quantity">
              <button type="button" data-cart-quantity="${index + 1}" data-quantity="${item.quantity - 1}" aria-label="Remove one">−</button>
              <span aria-live="polite">${item.quantity}</span>
              <button type="button" data-cart-quantity="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Add one">+</button>
            </div>
            <button class="cart-item__remove" type="button" data-cart-quantity="${index + 1}" data-quantity="0">Remove</button>
          </div>
        </div>
        <span class="cart-item__price">${discounted ? `<s>${money(item.original_line_price)}</s>` : ''}${money(item.final_line_price)}</span>
      </article>`;
    }).join('') + cartUpsell(cart);
    qs('[data-cart-subtotal]').textContent = money(cart.total_price);
    const savings = qs('[data-cart-savings]');
    if (savings) {
      savings.hidden = !cart.total_discount;
      savings.textContent = cart.total_discount ? `You save ${money(cart.total_discount)}` : '';
    }
    qsa('[data-cart-quantity]').forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        await cartRequest('/change.js', { line: Number(button.dataset.cartQuantity), quantity: Math.max(0, Number(button.dataset.quantity)) });
      } catch (error) { console.error(error); }
      const updated = await refreshCart();
      if (updated) checkBundlePrice(updated, 'cart_quantity');
    }));
    qsa('[data-cart-upsell]').forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      const quantity = Number(button.dataset.cartUpsell);
      const details = { cta_location: 'cart_drawer_upsell', product_id: offerConfig.product_id, variant_id: offerConfig.variant_id, purchase_type: 'one-time', quantity, price: bundleTotal(quantity) };
      try {
        await cartRequest('/add.js', { items: [{ id: Number(offerConfig.variant_id), quantity: 1 }] });
        track('ravira_cart_upsell_added', details);
        track('add_to_cart', { placement: 'cart_drawer_upsell', purchase_type: 'one-time', quantity });
      } catch (error) { console.error(error); }
      const updated = await refreshCart();
      if (updated) checkBundlePrice(updated, 'cart_upsell');
    }));
  }

  // A buy-box submit sets this product's cart lines to the selected option. Changing from
  // 2 bottles to 3, or from subscription to one-time, never leaves a second line behind.
  // Increases use /cart/add.js so Shopify's standard add-to-cart events still fire.
  async function applySelectionToCart(selection) {
    const cart = await cartRequest('.js');
    const lines = cart.items.filter((item) => String(item.variant_id) === String(selection.variant_id));
    const planOf = (item) => String(item.selling_plan_allocation?.selling_plan?.id || '');
    const same = lines.find((item) => planOf(item) === String(selection.selling_plan_id || ''));
    const updates = {};
    lines.filter((item) => item !== same).forEach((item) => { updates[item.key] = 0; });
    if (same && same.quantity > selection.quantity) updates[same.key] = selection.quantity;
    if (Object.keys(updates).length) await cartRequest('/update.js', { updates });
    const delta = selection.quantity - (same ? Math.min(same.quantity, selection.quantity) : 0);
    if (delta > 0) {
      const item = { id: Number(selection.variant_id), quantity: delta };
      if (selection.selling_plan_id) item.selling_plan = Number(selection.selling_plan_id);
      return cartRequest('/add.js', { items: [item] });
    }
    return null;
  }

  qsa('[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!cartDrawer || !window.fetch) return;
      event.preventDefault();
      const submit = qs('[type="submit"]', form);
      submit.disabled = true;
      submit.textContent = 'Adding…';
      const root = form.closest('[data-product-root]');
      const details = purchaseDetails(root, selectedOption(form));
      details.cta_location = form.dataset.submitSource || details.cta_location;
      delete form.dataset.submitSource;
      const ctaEvent = {
        primary_buybox: 'ravira_primary_buybox_cta',
        sticky_buybox: 'ravira_sticky_buybox_cta',
        final_offer: 'ravira_final_cta'
      }[details.cta_location] || 'ravira_midpage_cta';
      track(ctaEvent, details);
      track('cta_click', { placement: details.cta_location, purchase_type: details.purchase_type, quantity: details.quantity });
      try {
        const added = await applySelectionToCart(details);
        window.__raviraLastPurchase = details;
        track('ravira_add_to_cart', { ...details, cart_line_id: added?.items?.[0]?.key || null });
        track('add_to_cart', { placement: details.cta_location, purchase_type: details.purchase_type, quantity: details.quantity });
        const cart = await refreshCart();
        if (cart) checkBundlePrice(cart, details.cta_location);
        setDrawer(cartDrawer, true, cartOpen);
        submit.textContent = 'Added';
      } catch (error) {
        submit.textContent = 'Please try again';
        console.error(error);
      } finally {
        // Re-render from the current selection: the shopper may have changed it meanwhile.
        setTimeout(() => { submit.disabled = false; applyPurchaseSelection(root); }, 1200);
      }
    });
  });

  qsa('[data-product-root]').forEach((root) => {
    // Respect the guide's purchase choice before initializing prices and CTA text.
    // Other products and visits without this explicit choice retain their defaults.
    const guideChoice = campaignParams.get('ravira_purchase');
    if (body.dataset.pageType === 'product' && /\/products\/ashwagandha-plus-1\/?$/.test(window.location.pathname)
      && (guideChoice === 'subscription' || guideChoice === 'one-time')) {
      const requestedInput = qs(`[data-purchase-type="${guideChoice}"] input[name="selling_plan"]`, root);
      if (requestedInput && !requestedInput.disabled) requestedInput.checked = true;
    }
    qsa('[data-purchase-option] input', root).forEach((input) => input.addEventListener('change', () => {
      // Choosing an upgrade also selects the one-time purchase it belongs to.
      if (input.matches('[data-bundle-toggle]')) {
        const radio = qs('input[name="selling_plan"]', input.closest('[data-purchase-option]'));
        if (radio) radio.checked = true;
      }
      applyPurchaseSelection(root, true);
    }));
    applyPurchaseSelection(root);
    track('ravira_purchase_type_defaulted', purchaseDetails(root));
    const variantSelect = qs('[name="id"]', root);
    const variantData = qs('[data-variant-json]', root);
    if (variantSelect && variantData) {
      const variants = JSON.parse(variantData.textContent);
      variantSelect.addEventListener('change', () => {
        const variant = variants.find((item) => String(item.id) === variantSelect.value);
        if (!variant) return;
        qsa('[data-product-price]', root).forEach((node) => { node.textContent = money(variant.price); });
        qsa('[data-purchase-type="one-time"]', root).forEach((node) => { node.dataset.unitPrice = variant.price; });
        const single = qs('[data-purchase-type="one-time"]:not([data-bundle-option])', root);
        if (single) {
          single.dataset.purchasePrice = variant.price;
          single.dataset.purchaseDisplayPrice = money(variant.price);
          single.dataset.purchaseCta = `Add to Cart · ${money(variant.price)}`;
          const optionPrice = qs('.product-form__option-price, .purchase-option__price', single);
          if (optionPrice) optionPrice.textContent = money(variant.price);
        }
        const button = qs('[data-add-button]', root);
        if (button) button.disabled = !variant.available;
        applyPurchaseSelection(root);
        if (button && !variant.available) button.textContent = 'Sold out';
      });
    }
  });

  const primaryProductRoot = qs('[data-purchase-location="primary_buybox"]');
  if (body.dataset.pageType === 'product' && primaryProductRoot) {
    track('ravira_pdp_view', purchaseDetails(primaryProductRoot));
  }

  if ('IntersectionObserver' in window) {
    qsa('[data-product-root]').forEach((root) => {
      const offerObserver = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) return;
        track('ravira_offer_view', purchaseDetails(root));
        offerObserver.disconnect();
      }, { threshold: .2 });
      offerObserver.observe(root);
    });
  }

  qsa('[data-gallery]').forEach((gallery) => {
    const thumbs = qsa('[data-gallery-thumb]', gallery);
    const media = qsa('.product-gallery__media', gallery);
    const current = qs('[data-gallery-current]', gallery);
    const total = qs('[data-gallery-total]', gallery);
    const stage = qs('[data-gallery-stage]', gallery);
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true'));
    if (total) total.textContent = String(media.length);
    const showMedia = (index, report = true) => {
      if (!media.length) return;
      activeIndex = (index + media.length) % media.length;
      thumbs.forEach((node) => node.setAttribute('aria-current', 'false'));
      media.forEach((node) => node.classList.remove('is-active'));
      if (thumbs[activeIndex]) {
        thumbs[activeIndex].setAttribute('aria-current', 'true');
        if (report) thumbs[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
      media[activeIndex].classList.add('is-active');
      if (current) current.textContent = String(activeIndex + 1);
      if (report) {
        const galleryDetails = { media_index: activeIndex + 1, media_label: thumbs[activeIndex]?.dataset.galleryLabel || '' };
        track('ravira_gallery_interaction', galleryDetails);
        track('product_gallery_interaction', galleryDetails);
      }
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
    if (stage) {
      let touchStartX = 0;
      stage.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        const distance = (event.changedTouches[0]?.clientX || 0) - touchStartX;
        if (Math.abs(distance) < 45) return;
        showMedia(activeIndex + (distance < 0 ? 1 : -1));
      }, { passive: true });
    }
    showMedia(activeIndex, false);
    const hashLabel = window.location.hash.replace('#', '');
    const hashIndex = thumbs.findIndex((thumb) => thumb.dataset.galleryLabel === hashLabel);
    if (hashIndex >= 0) {
      showMedia(hashIndex, false);
      requestAnimationFrame(() => gallery.scrollIntoView({ block: 'start' }));
    }
  });

  qsa('.product-accordions details, .faq__items details, .clinical__disclosure').forEach((details) => details.addEventListener('toggle', () => {
    if (!details.open) return;
    const accordion = qs('summary', details)?.textContent.trim() || '';
    track('ravira_accordion_open', { accordion, location: details.closest('.product-accordions') ? 'pdp_buybox' : details.classList.contains('clinical__disclosure') ? 'science' : 'faq' });
    track(details.closest('.product-accordions') ? 'pdp_accordion_open' : 'faq_open', { accordion });
  }));

  qsa('[data-track-cta]').forEach((link) => link.addEventListener('click', () => {
    const placement = link.dataset.trackCta;
    const eventName = placement === 'homepage_hero' ? 'ravira_hero_cta_click' : placement === 'final_cta' ? 'ravira_final_cta' : 'ravira_midpage_cta';
    track(eventName, { cta_location: placement, destination: link.href });
    track('cta_click', { placement });
  }));
  qsa('[data-track-science]').forEach((link) => link.addEventListener('click', () => {
    track('ravira_science_study_click', { destination: link.href, study_label: link.textContent.trim() });
    track('science_section_engagement', { destination: link.href });
  }));
  qsa('[data-track-checkout]').forEach((link) => link.addEventListener('click', () => {
    const checkoutDetails = { ...(window.__raviraLastPurchase || {}), cta_location: link.dataset.trackCheckout || 'cart_drawer' };
    track('ravira_checkout_initiated', checkoutDetails);
    track('checkout_initiated', checkoutDetails);
  }));
  const comparison = qs('[data-track-comparison]');
  if (comparison && 'IntersectionObserver' in window) {
    const comparisonObserver = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      track('comparison_section_view');
      comparisonObserver.disconnect();
    }, { threshold: .35 });
    comparisonObserver.observe(comparison);
  }

  qsa('[data-gallery-jump]').forEach((link) => link.addEventListener('click', (event) => {
    const gallery = qs('[data-gallery]');
    const target = gallery && qs(`[data-gallery-label="${link.dataset.galleryJump}"]`, gallery);
    if (!target) return;
    event.preventDefault();
    target.click();
    gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  const mainPurchase = qs('[data-main-purchase]');
  const sticky = qs('[data-sticky-atc]');
  if (mainPurchase && sticky) {
    const primaryButton = qs('[data-add-button]', mainPurchase);
    const finalOffer = qs('#final-offer');
    let stickyFrame = 0;
    const updateSticky = () => {
      stickyFrame = 0;
      const primaryPassed = primaryButton && primaryButton.getBoundingClientRect().bottom < 0;
      const finalRect = finalOffer?.getBoundingClientRect();
      const finalOfferVisible = finalRect && finalRect.top < innerHeight && finalRect.bottom > 0;
      const visible = Boolean(primaryPassed && !finalOfferVisible);
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
    };
    window.addEventListener('scroll', () => {
      if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky);
    }, { passive: true });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();
    const stickyButton = qs('[data-sticky-submit]', sticky);
    if (stickyButton) stickyButton.addEventListener('click', () => {
      const details = purchaseDetails(mainPurchase.closest('[data-product-root]'));
      mainPurchase.dataset.submitSource = 'sticky_buybox';
      track('sticky_cta_click', { purchase_type: details.purchase_type });
      qs('[type="submit"]', mainPurchase)?.click();
    });
  }

  const homeSticky = qs('[data-home-sticky]');
  if (homeSticky) {
    const heroCta = qs('[data-track-cta="homepage_hero"]');
    const firstOffer = qs('#offer');
    const finalOffer = qs('#final-offer');
    let homeStickyFrame = 0;
    const elementVisible = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.top < innerHeight && rect.bottom > 0;
    };
    const updateHomeSticky = () => {
      homeStickyFrame = 0;
      const heroPassed = heroCta && heroCta.getBoundingClientRect().bottom < 0;
      const visible = Boolean(heroPassed && !elementVisible(firstOffer) && !elementVisible(finalOffer));
      homeSticky.classList.toggle('is-visible', visible);
      homeSticky.setAttribute('aria-hidden', String(!visible));
    };
    window.addEventListener('scroll', () => {
      if (!homeStickyFrame) homeStickyFrame = requestAnimationFrame(updateHomeSticky);
    }, { passive: true });
    window.addEventListener('resize', updateHomeSticky, { passive: true });
    updateHomeSticky();
    qs('[data-home-sticky-cta]', homeSticky)?.addEventListener('click', () => {
      track('ravira_sticky_buybox_cta', { cta_location: 'homepage_sticky', destination: '#offer' });
      track('sticky_cta_click', { placement: 'homepage_sticky' });
    });
  }
})();
